import React from "react";
import { ArrowUpRight } from "lucide-react";
import Reveal from "./Reveal";
import { JOURNAL } from "../data/data";

export function Journal() {
  return (
    <section id="journal" className="py-24 px-6 md:px-10" style={{ background: "#12161F" }}>
      <div className="max-w-7xl mx-auto">
        <Reveal>
          <p className="uppercase tracking-widest text-xs mb-3" style={{ fontFamily: "'JetBrains Mono', monospace", color: "#1E9AFF" }}>
            From The Journal
          </p>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 style={{ fontFamily: "Fraunces, serif" }} className="text-4xl md:text-5xl mb-14">
            Stories worth reading
          </h2>
        </Reveal>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {JOURNAL.map((j, i) => (
            <Reveal key={j.title} delay={i * 0.08}>
              <a
                href="/"
                className="group block rounded-2xl overflow-hidden transition-transform duration-200 active:scale-95"
                style={{ background: "#171B22" }}
              >
                <div className="relative h-52 overflow-hidden">
                  <img
                    src={j.image}
                    alt={j.title}
                    loading="lazy"
                    className="absolute inset-0 w-full h-full transition-transform duration-500 group-hover:scale-105"
                    style={{ objectFit: "cover" }}
                  />
                </div>
                <div className="p-5">
                  <p
                    className="text-xs uppercase tracking-widest opacity-60 mb-2"
                    style={{ fontFamily: "'JetBrains Mono', monospace", color: "#1E9AFF" }}
                  >
                    {j.category}
                  </p>
                  <div className="flex items-center justify-between gap-3">
                    <h3 style={{ fontFamily: "Fraunces, serif" }} className="text-lg leading-snug">
                      {j.title}
                    </h3>
                    <ArrowUpRight
                      size={18}
                      className="flex-shrink-0 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1"
                    />
                  </div>
                </div>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Journal;
